import { Table as MUITable, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styles from '@styles/components/FrequencyTable.module.css';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { TableVirtuoso } from 'react-virtuoso';

import { ReactComponent as FilterSVg } from '@assets/SVGs/GeneralUse/Filter.svg';

/* 
    rowTemplate is a function that returns a React element. It is called for each row in the table.
*/

const ColumnWithFilter = ({column}) => {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClickOnFilter = (event) => {
    column.onFilterClick?.();
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
};

  return (
      <TableCell
        key={column.dataKey}
        variant="head"
        align={'center'}
        sx={[{backgroundColor: '#F6F7F9', ...column.style}, column.size && { width: column.size, maxWidth: column.size }]}
      >
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>

          {column.label}

          <div className={styles['filter-container']} onClick={handleClickOnFilter}>
            <FilterSVg />
            {open && <column.component {...column.componentProps} isOpen={open} anchorElement={anchorEl} clickAwayHandler={() => setOpen(false)} />  }
          </div>

        </div>
      </TableCell>
    )
}

const Column = ({column}) => {
  return (
      <TableCell
        key={column.dataKey}
        variant="head"
        align={'center'}
        sx={[{backgroundColor: '#F6F7F9', ...column.style}, column.size && { width: column.size, maxWidth: column.size }]}
      >
        {column.label}
      </TableCell>
    )
}

const Table = ({loading, dataForRows, columns, rowTemplate, placeHolder = 'No hay información para esta búsqueda o día!'}) => {

  const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <MUITable {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead,
    TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
    EmptyPlaceholder: () => {
      return (!loading &&
        <TableBody>
          <TableRow>
            <TableCell style={{borderBottom: '0px'}}>
              <div className={styles['no-rows-text']} style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: '1.5rem',
                color: '#c4c3c3',
              }}>
                {placeHolder}
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
        );
      },
    };

    function fixedHeaderContent() {
        return (
          <TableRow>
            {columns.map((column) => (
              !column.component ?
              <Column column={column}/> :
              <ColumnWithFilter column={column} />
            ))}
          </TableRow>
        );
    }


    const [rows, setRows] = useState([])

    useEffect(() => {
      if (dataForRows) {
        setRows(dataForRows)
      } else {
        setRows([])
      }
    }, [dataForRows])


    return (
        <Paper sx={{
            height: '100%',
            width: '100%',
        }} elevation={0}>
            <TableVirtuoso
                data={rows}
                components={VirtuosoTableComponents}
                fixedHeaderContent={fixedHeaderContent}
                itemContent={loading ? () => <div style={{ height: '1px' }}/> : rowTemplate}
                className={loading ? styles['skeleton'] : ''}
                style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
            />
        </Paper>
  );
}

export default Table